import ConfirmationModalBase from "@/components/common/modals/confirmation-modal-base";

export type DataCenterConfirmationModalMode =
  | "delete-data"
  | "deactivate-table"
  | "delete-option"
  | "save"
  | "exit"
  | "off";

interface Props {
  isOpen: boolean;
  mode: DataCenterConfirmationModalMode;
  onClose: () => void;
  onAccept: () => void;
  isLoading?: boolean;
}

const DataCenterConfirmationModal = ({
  mode,
  isOpen,
  onClose,
  onAccept,
  isLoading = false,
}: Props) => {
  const getModalContent = () => {
    switch (mode) {
      case "exit":
        return {
          title: "Salir sin guardar",
          description:
            "¿Estás seguro de que deseas salir? Todos los cambios que hayas realizado se perderán",
          acceptText: "Salir sin guardar",
          acceptVariant: "danger-secondary" as const,
        };
      case "delete-data":
        return {
          title: "Eliminar registros",
          description:
            "¿Estás seguro de que deseas eliminar los registros de la lista? Se eliminará la información de todas sus celdas.",
          acceptText: "Eliminar",
          acceptVariant: "danger-secondary" as const,
        };
      case "save":
        return {
          title: "Guardar cambios",
          description:
            "¿Estás seguro de que deseas guardar todos los cambios realizados en la tabla actual?",
          acceptText: "Guardar Cambios",
          acceptVariant: "default" as const,
        };
      case "deactivate-table":
        return {
          title: "Desactivar tabla",
          description:
            "¿Estás seguro de que deseas desactivar la tabla? Se ocultará de la vista principal y no podrás usar sus datos.",
          acceptText: "Desactivar tabla",
          acceptVariant: "danger-secondary" as const,
        };
      case "delete-option":
        return {
          title: "Eliminar opción",
          description:
            "¿Estás seguro de que deseas eliminar esta opción de la lista? Se eliminará de todas las celdas utilizando este item.",
          acceptText: "Eliminar opción",
          acceptVariant: "danger-secondary" as const,
        };
      default:
        return {
          title: "",
          description: "",
          acceptText: "",
          acceptVariant: "default" as const,
        };
    }
  };

  const { title, description, acceptText, acceptVariant } = getModalContent();

  return (
    <ConfirmationModalBase
      isOpen={isOpen}
      onClose={onClose}
      onAccept={onAccept}
      title={title}
      description={description}
      acceptText={acceptText}
      acceptVariant={acceptVariant}
      isLoading={isLoading}
    />
  );
};

export { DataCenterConfirmationModal };
